import { FC, useEffect, useState } from "react"
import useSWR from "swr"
import { CACHE_KEYS, SWR_CONFIG } from "../util/breed-page"
import xml2js from "xml2js"
import { Anchor } from "src/app/components/anchor"
interface RSSItem {
  title: string[]
  link: string[]
  description: string[]
  pubDate: string[]
  ["content:encoded"]?: string[]
  ["dc:creator"]?: string[]
  category?: string[]
  guid?: string[]
}

interface RSSFeedProps {
  url: string
  setIsShown: (shown: boolean) => void
}

const cleanContent = (content: string) => {
  if (!content) return ""
  return content
    .replace(/<p>The post .*? appeared first on .*?<\/p>/g, "")
    .trim()
    .replace(/<p>The post .*? appeared first on .*?<\/p>/g, "")
    .replace(/<p>.*?CitizenShipper Blog.*?<\/p>/g, "")
    .trim()
}

const RSSFeed: FC<RSSFeedProps> = ({ url, setIsShown }) => {
  const { data: rawRSSData, error } = useSWR<string>(
    url ? CACHE_KEYS.RSS_FEED(url) : null,
    null,
    SWR_CONFIG,
  )
  const [feedItems, setFeedItems] = useState<RSSItem[]>([])

  useEffect(() => {
    if (!url || error || !rawRSSData) {
      setIsShown(false)
      return
    }

    const parser = new xml2js.Parser()
    parser.parseString(rawRSSData, (err: Error | null, result: any) => {
      if (err) {
        console.error("Error parsing XML:", err)
        setIsShown(false)
        return
      }

      const items = result?.rss?.channel?.[0]?.item || []
      setFeedItems(items)
      setIsShown(items.length > 0)
    })
  }, [url, rawRSSData, error, setIsShown])

  if (!feedItems.length || error) {
    return null
  }

  return (
    <div className="space-y-4">
      {feedItems.map((item: RSSItem, index) => {
        const key =
          (item.guid && typeof item.guid[0] === "string"
            ? item.guid[0]
            : item.link?.[0]) || `item-${index}`

        return (
          <div
            className="bg-white p-5 shadow-sm border border-text-gray rounded"
            key={key}
          >
            <article className="space-y-3">
              <h3 className="text-xl font-semibold">
                <Anchor
                  href={item.link[0] ?? ""}
                  target="_blank"
                  className="inline-block mt-2 text-blue-600 hover:underline"
                  rel="noopener noreferrer"
                >
                  {item.title[0]}
                </Anchor>
              </h3>
              <div
                className="prose my-2 prose-base max-w-none line-clamp-2 overflow-hidden"
                dangerouslySetInnerHTML={{
                  __html: cleanContent(item.description[0] || ""),
                }}
              />
              <Anchor
                href={item.link[0] ?? ""}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-2 text-blue-600 hover:underline"
              >
                Read More on CitizenShipper Blog →
              </Anchor>
            </article>
          </div>
        )
      })}
    </div>
  )
}

export default RSSFeed
